import { CardHeader } from '../../../card/app';
import { ICardHeaderProps } from '../../../card/interface';
import { ColumnFilter } from '../column-filter';
import { DeleteButton } from '../../../button/delete-button';
import Button from '../../../button';
import { useTableContext } from '../with-provider';
import { Trash } from 'lucide-react';

export const withContainer =
  (Component: React.FC<any>) =>
  ({
    withCard = true,
    title,
    subTitle,
    tooltipText,
    ...props
  }: IContainerProps) => {
    if (!withCard) return <Component {...props} />;

    const { selectedRows } = useTableContext();

    return (
      <CardHeader
        title={title}
        subTitle={subTitle}
        tooltipText={tooltipText}
        cardFooter={!props?.page && props?.cardFooter}
        id={`card-${props?.id}`}
        className={props?.cardClassName}
        headerActions={
          <div className="flex flex-wrap gap-2">
            {props.onDeleteAll && (
              <DeleteButton
                title="Tem certeza que deseja excluir todas as transações?"
                subTitle="Esta ação não poderá ser desfeita."
                onDelete={props.onDeleteAll}
                disabled={!!selectedRows.length || props?.onDeleteAllDisabled}
              >
                <Button
                  variant="outlined"
                  color="inherit"
                  size="small"
                  startIcon={<Trash color="#CA5050" />}
                  disabled={!!selectedRows.length || props?.onDeleteAllDisabled}
                >
                  Excluir todas
                </Button>
              </DeleteButton>
            )}
            {props.headerActions}
            {props.enableColumnsFilter && (
              <ColumnFilter id="wallet_composition_table" />
            )}
          </div>
        }
      >
        <Component {...props} />
      </CardHeader>
    );
  };

export type IContainerProps = {
  enableColumnsFilter?: boolean;
  cardClassName?: string;
  id?: string;
  withCard?: boolean;
  title?: string;
  page?: number;
  tableConfigName?: string;
  onDeleteAll?: (item: any) => Promise<void>;
  onDeleteAllDisabled?: boolean;
} & Partial<ICardHeaderProps>;
